import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input
} from '@angular/core';
import { ColorService } from '../../../../v2-components/services/color.service';

@Component({
  selector: 'v2-forked-edge-banner',
  template: `
    <ng-content></ng-content>
    <div
      id="top-triangle"
      class="triangle"
      [style]="'background: ' + hexColor"
    ></div>
    <div
      id="bottom-triangle"
      class="triangle"
      [style]="'background: ' + hexColor"
    ></div>
  `,
  styleUrls: ['v2-forked-edge-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class V2ForkedEdgeBanner {
  @Input() hexColor: string | undefined | null = this.colorService.white;
  @Input() size: 'small' | 'medium' | undefined | null = 'small';

  @HostBinding('style') private get style() {
    return `background-color: ${this.hexColor}`;
  }

  @HostBinding('class') private get class() {
    return `size-${this.size}`;
  }

  constructor(private colorService: ColorService) {}
}
